import {
	SystemConfig,
	SystemConfigActionTypes,
	SystemSetConfigsAction,
} from '../../../types/systemConfig'

const initialState: SystemConfig = {
	loading: false,
	error: null,
	system: {
		taskPriorities: [],
		taskStatuses: [],
		taskReminders: [],
		taskTypes: [],
		taskCategories: [],
		workflowProcesses: [],
		workflowStages: [],
		eventTypes: [],
		eventCategories: [],
		eventReminders: [],
		countries: [],
		eventStatuses: [],
		martialStatus: [],
		roles: [],
		roleTypes: [],
		diabetesType: [],
		insulinTreatment: [],
		smoking: [],
		comorbiditiesOpts: [],
		languageRegion: [],
		carbs: [],
		timezones: [],
		gender: [],
		age: [],
		taskStatusesV2: {
			externalClinic: [],
			internalClinic: [],
		},
	},
	uiTabs: {},
	configuration: {
		accountsRef: [],
		sms: {
			templates: [],
			languages: [],
		},
		userTitle: [],
		skills: [],
		expertises: [],
		eventCategoriesV2: [],
	},
	about: {},
	dropDowns: {
		report_type: [],
		reports_period: [],
	},
	templates: {
		checklist: [],
	},
	userConfig: {
		myOrganization: {
			membershipEnrollment: {
				products: [],
			},
		},
	},
}

export default (
	state = initialState,
	action: SystemSetConfigsAction
): SystemConfig => {
	switch (action.type) {
		case SystemConfigActionTypes.SYSTEM_CONFIGS_GET: {
			return {
				...state,
				...action.payload,
			}
		}
		case SystemConfigActionTypes.USER_CONFIG_DATA_GET: {
			return {
				...state,
				userConfig: action.payload,
			}
		}
		default:
			return state
	}
}
